module.exports = __webpack_public_path__ + "static/media/20_before.b8cf5092.jpg";